/*
  Salt Hound Editorial Hero v6.1
  Subtle parallax engine
*/

document.addEventListener('DOMContentLoaded', function () {
  const heroes = document.querySelectorAll('[data-sh-hero]');

  if (!heroes.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  function updateHeroParallax() {
    heroes.forEach(function (hero) {
      if (!hero.classList.contains('sh-hero-parallax')) return;

      const media = hero.querySelector('[data-sh-hero-media]');
      if (!media) return;

      const rect = hero.getBoundingClientRect();
      const progress = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
      const translate = (progress - 0.5) * 18;

      media.style.transform = 'translate3d(0,' + translate + 'px,0)';
    });
  }

  updateHeroParallax();
  window.addEventListener('scroll', updateHeroParallax, { passive: true });
  window.addEventListener('resize', updateHeroParallax);
});